import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Stack,
  TextField,
} from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { useRef } from "react";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";

import { styled, useTheme } from "@mui/material/styles";
import { useState } from "react";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import AgGridTable from "src/app/main/utilities/AgGridTable";
import DirectoryFilter from "./DirectoryFilter";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import FormPageHeader from "../../utilities/FormPageHeader";
import "../expense-claim/expenseClaim.css";

const expenseListURL = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.expenseClaimList}`;

const StyledTextField = styled(TextField)(({ theme }) => ({
  "& input": {
    padding: "10px 14px",
  },
}));
const payGroupOptions = [
  { label: "ALL", value: "ALL" },
  { label: "Nolte FZE", value: "Nolte FZE" },
  { label: "FREE LANCE", value: "FREE LANCE" },
  { label: "IT CONSULTANT", value: "IT CONSULTANT" },
];
const Gratuity = () => {
  const gridRef = useRef();
  const [gridApi, setGridApi] = useState(null);
  const navigate = useNavigate();

  const [rowData, setRowData] = useState([
    {
      code: "01",
      empName: "Gokulnath",
      department: "IT Consultant",
      subDepartment: "Development",
      designation: "Software Engineer",
    },
    {
      code: "02",
      empName: "Gokulnath",
      department: "IT Consultant",
      subDepartment: "Development",
      designation: "Software Engineer",
    },
    {
      code: "03",
      empName: "Gokulnath",
      department: "IT Consultant",
      subDepartment: "Development",
      designation: "Software Engineer",
    },
    {
      code: "04",
      empName: "Gokulnath",
      department: "IT Consultant",
      subDepartment: "Development",
      designation: "Software Engineer",
    },
  ]);
  const [columnDefs, setColumnDefs] = useState([
    {
      field: "code",
      headerName: "Code",
      filter: "agNumberColumnFilter",
    },
    {
      field: "empName",
      headerName: "Employee Name",
      // cellRenderer: PostingCheckboxRenderer,
    },

    {
      field: "designation",
      headerName: "Designation",
    },
    {
      field: "dateOfJoining",
      headerName: "Date of Joining",
    },
    {
      field: "basicSalary",
      headerName: "Basic Salary",
    },
    {
      field: "cutOffDate",
      headerName: "Cut of Date",
    },
    {
      field: "numberOfDays",
      headerName: "Number of Days",
    },
    {
      field: "currentMonthGratuity",
      headerName: "Current Month Gratuity",
    },
    {
      field: "provisionRecalculation",
      headerName: "Provision Recalculation",
    },
  ]);
  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const loadData = async () => {
    try {
      const list = await OAuthService.getList(expenseListURL);
      // let expenseClaimList = list.data._embedded.expenses;
    } catch (error) {
      setError(error.message);
    }
  };

  useEffect(() => {
    if (gridApi) {
      loadData();
    }
  }, [gridApi]);
  const onRowDoubleClicked = (params) => {
    navigate("/payroll/employee/profile");
  };

  const onSelectionChanged = (params) => {
    setSelectedRows(params.api.getSelectedRows());
  };
  const getContextMenuItems = (event) => {
    var result = [
      {
        name: "View",
        icon: '<span><i class="material-icons" style="font-size: 18px">visibility</i></span>',
        action: (props) => {
          navigate(
            `/payroll/salary/revision/action?val=view&id=${event.node.data.code}`
          );
        },
      },
      {
        name: "Edit",
        icon: '<span><i class="material-icons" style="font-size: 18px">edit</i></span>',
        action: (props) => {
          navigate(
            `/payroll/salary/revision/action?val=edit&id=${event.node.data.code}`
          );
        },
      },
      {
        name: "Print",
        icon: '<span><i class="material-icons" style="font-size: 18px">print</i></span>',
        action: (props) => {
          // navigate(`/expense-claim/add?id=${event.node.data.id}`);
        },
      },

      // {
      //   name: "Delete",
      //   icon: '<span><i class="material-icons" style="font-size: 18px">delete</i></span>',
      //   action: () => {
      //     onDelete(event);
      //   },
      // },
    ];
    return result;
  };
  return (
    <React.Fragment>
      <FormPageHeader
        componentName="List"
        pageName="Gratuity"
        currentPage="Gratuity"
      />

      <Stack direction={"row"} className={"items-end"} sx={{ padding: 2 }}>
        <Stack className="mr-16">
          As of Period
          <Stack direction="row">
            <TextField
              className="mb-4 w-[50px]"
              type="text"
              required
              variant="outlined"
              fullWidth
              sx={{ mr: 2 }}
            />
            <TextField
              className="mb-4 w-[100px]"
              type="text"
              variant="outlined"
              fullWidth
            />
          </Stack>
        </Stack>
        <Stack className="mr-16">
          Emp Code
          <StyledTextField
            type="text"
            className="w-[80px]"
            variant="outlined"
            name="year"
          />
        </Stack>
        <Stack className="mr-16">
          Emp Name
          <Select
            className="w-[150px]"
            name="approval_status"
            placeholder="Status"
            options={payGroupOptions}
            styles={customStyles()}
          />
        </Stack>
        <Stack className="mr-16">
          Department
          <Select
            className="w-[150px]"
            name="approval_status"
            placeholder="Status"
            options={payGroupOptions}
            styles={customStyles()}
          />
        </Stack>
        <Stack className="mr-16">
          Designation
          <Select
            className="w-[150px]"
            name="approval_status"
            placeholder="Status"
            options={payGroupOptions}
            styles={customStyles()}
          />
        </Stack>

        <Button
          color="warning"
          variant="contained"
          startIcon={
            <FuseSvgIcon size={18}>heroicons-outline:search</FuseSvgIcon>
          }
          sx={{ mr: 1 }}
        />
        <Button
          color="warning"
          variant="contained"
          startIcon={<FuseSvgIcon size={18}>heroicons-outline:cog</FuseSvgIcon>}
          sx={{ mr: 1 }}
          onClick={() => navigate("/gratuity/master")}
        />
      </Stack>

      <AgGridTable
        hideCheckbox={true}
        columnDefs={columnDefs}
        onGridReady={onGridReady}
        gridRef={gridRef}
        rowData={rowData}
        getContextMenuItems={getContextMenuItems}
        editable={false}
        pagination={false}
        onSelectionChanged={onSelectionChanged}
        // onRowDoubleClicked={onRowDoubleClicked}
      />
    </React.Fragment>
  );
};

export default Gratuity;
